<template>
<div class=" wrapper"   v-loading.fullscreen.lock="loading" :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="page__card">
        <div class="page__card-title">
            <button class="bg-indigo-400 p-1 w-8 h-8 mr-2 rounded-xl" @click="$router.push(`/?page=4&${router_link}`)">
                <i class="el-icon-arrow-left"></i>
            </button>
            <h1> {{$route.query.district}} {{$t('building_list').toLowerCase()}}</h1>
        </div>
    <div class="wp-body obj-list">
        <header class="wp-header flex flex-col ">
            <div class="cover flex justify-between items-center mb-3 pr-3 w-full">
                <div>
                    <p class="fw-600 fs-20 c-dark-blue">{{filtertype[seltype-1].label}} {{$t('building_list').toLowerCase()}}:</p>
                </div>
                <div class="flex items-center justify-end  bb fw-w" style="flex:1; padding-left:50px; max-width:300px;">
                    <el-select :placeholder="$t('building_category')" class="mt-2 mb-2 mw-100"   @change="__GET()" v-model="seltype"   clearable>
                        <el-option v-for="(item, i) in filtertype" :key="i" :label="item.label" :value="i+1">
                        </el-option>
                    </el-select>
                    
                </div>
            </div>
        </header>

        <el-table ref="multipleTable" :data="buildsList" class="mt-5" style="width: 100%; margin-bottom: 20px;" row-key="id" @selection-change="handleSelectionChange" stripe default-expand-all>
            <el-table-column v-if="select_invest && ['operator'].includes(role)"  type="selection" width="50"  > </el-table-column>
            <el-table-column label="№" width="50" align="center">
                <template slot-scope="scope">
                    {{ (current_page-1)*item_count + (scope.$index + 1) }}
                </template>
            </el-table-column>
            <el-table-column v-if="me.role.name == 'admin'" prop="cadastral_number" :label="$t('cadaster_number')"  sortable width="200px">
                <template slot-scope="scope">
                    <p class="rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 leading-snug w-max cursor-pointer" 
                    @click="routeTo(scope.row, 0)">{{
                        scope.row.cadastral_number }}</p>
                </template>
            </el-table-column>
            <el-table-column :label="$t('building_name')"  sortable min-width="250px">
                <template slot-scope="scope">
                    <p> {{scope.row.name_cyr?scope.row.name_cyr : '***' }} </p>
                </template>
            </el-table-column>
            <el-table-column :label="$t('building_address')" prop="address"  sortable min-width="200px">
            </el-table-column>
            <el-table-column :label="$t('created_at')" prop="created_at"  sortable min-width="140px">
            </el-table-column>
            <el-table-column :label="$t('year_construction')" prop="year_construction"  sortable min-width="120px">
            </el-table-column>
            <el-table-column prop="finalconclusion" :label="$t('finalconclusion')"  sortable min-width="120px">
                <template slot-scope="scope">
                    <p 
                        class="finalconclusion"
                        :class="`fc__bg-${scope.row.finalconclusion}`">{{scope.row.finalconclusion}}</p>
                    </template>
            </el-table-column>
            <el-table-column :label="$t('building_type')" prop=""  sortable width="130px">
                <template slot-scope="scope">
                    <span :class="buildingtype === 'NEW' ? 'new_build' : 'exist_build'" class="px-2.5 py-1 rounded-lg "
                        size="small" :type="buildingtype === 'NEW' ? 'success' : 'info'">{{
                            scope.row.buildingtype === "NEW"
                            ? $t("new_building")
                            : $t("existing_building")
                        }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('investment_project')" prop="is_invest"    width="130px">
              <template slot-scope="scope">
                <InvestmentSwitch v-if="scope.row.buildingtype !== 'NEW'" v-model="scope.row.is_invest" :id="scope.row.id" :disabled="role!='operator'" />
              </template>
            </el-table-column>
            <el-table-column :label="$t('created_by')"  sortable min-width="150px">
                <template slot-scope="scope">
                    <div class="table-link-button" @click="UserModal(scope.row.created_by)">
                        {{scope.row.created_by!=null && scope.row.created_by.profile!=null ? scope.row.created_by.profile.name+" "+scope.row.created_by.profile.surname : '-' }}
                    </div>
                </template>
            </el-table-column> 
            <el-table-column :label="$t('updated_by')"  sortable min-width="150px">
                <template slot-scope="scope">
                    <div class="table-link-button" @click="UserModal(scope.row.updated_by)">
                        {{scope.row.updated_by!=null && scope.row.updated_by.profile!=null ? scope.row.updated_by.profile.name +" "+ scope.row.updated_by.profile.surname : '-' }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('actions')" width="180" >
                <template slot-scope="scope">
                <div class="flex items-center gap-2">
                    <button v-if="role == 'admin'"
                        type="button"
                        class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl flex items-center justify-center"
                        @click="GeneratePasport(scope.row.id)">
                        <HDocumentText/>
                    </button>
                    <button @click="DownloadExel(scope.row.id, scope.row.name_cyr)"
                        type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
                        <HFileDownload/>
                    </button>
                    <button v-if="(role!='admin' && role !== 'org_admin')&&!(role == 'operator' && scope.row.buildingtype == 'NEW')" @click="routeTo(scope.row, '1')"
                        type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
                        <HEye v-if="role === 'supervisor'"/>
                        <HEdit v-else/>
                    </button>
                </div>
                </template>
            </el-table-column>

        </el-table>
        <!-- <el-pagination v-if="page_count" style="margin-left: auto; margin-top: auto" class="ml-auto" @current-change="paginate" :current-page.sync="current_page" :hide-on-single-page="true" background layout="prev, pager, next" :page-count="page_count">
        </el-pagination> -->
        <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]" :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page1" :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count">
        </el-pagination>
        <el-drawer :title="$t('building_passport')" :visible.sync="drawer" direction='rtl'>
            <div>
                <div class="pdf">
                    <vue-pdf ref="print" :src="pdf"></vue-pdf>
                    <div class="loading-pdf" v-show="loadDawer">
                        <i class="el-icon-loading"></i>
                    </div>
                </div>
                <div class="w-full pdf-control">
                    <button class="button add__button" @click="downloadFile(pdf)"><i class="el-icon-download mr-2"></i> {{$t('download')}}</button>
                    <a :href="pdf" target="_blank">
                        <button class="ml-3 button dark-blue"><i class="el-icon-view mr-2"></i> {{$t('see')}}</button>
                    </a>
                </div>
            </div>
        </el-drawer>
        <div class="modal fs-14" v-if="usermodal">
            <div class="modal-cover"></div>
                <div class="modal-item p-3 sm:p-7 pt-0" style="max-width:664px; ">
                    <div class="flex justify-between items-center py-7">
                        <p class="modal-title text-slate-950" style="margin: 0; font-size: 24px; line-height: 33px; font-weight: 700; ">{{$t('user_date')}}:</p>
                        <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="usermodal=false">
                            <h-remove-circle/>
                        </button>
                    </div>
                    <div class="flex flex-wrap -my-1 sm:-my-2.5 -mx-1">
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-user class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex flex-wrap gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('last_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.surname }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('first_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.name }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('mid_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.middlename }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-home class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('organisation_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.organization && userData.organization.name_cyr ? userData.organization.name_cyr : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-call class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('phone_munber')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.phone_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-mail class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('user_email')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.email ? userData.profile.email : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div> 
    </div>
</div>
</template>

<script>
import HAddCircle from '../../components/Icons/hAddCircle.vue';
import HFileDownload from "@/components/Icons/hFileDownload.vue";
import HDocumentText from "@/components/Icons/hDocumentText.vue";
import HEdit from "@/components/Icons/hEdit.vue";
import HEye from "@/components/Icons/hEye.vue";
import HUser from '@/components/Icons/hUser.vue';
import HHome from '@/components/Icons/hHome.vue';
import HCall from '@/components/Icons/hCall.vue';
import HMail from '@/components/Icons/hMail.vue';
import HRemoveCircle from "@/components/Icons/hRemoveCircle.vue";
import Moment from 'moment';
import {
    extendMoment
} from 'moment-range';
const moment = extendMoment(Moment);
export default {
    components: {
         HAddCircle,
         HFileDownload,
         HDocumentText,
        HEdit, HEye,
        HUser,
        HHome,
        HCall,
        HMail,
        HRemoveCircle
    },
    data() {
        return {
            input2: null,
            drawer: false,
            pdf: '',
            namePdf: '',
            loadDawer: false,
            page_count: 0,
            buildsList: [],
            buildinggroup: '',
            current_district: [],
            objInfo: {}, 
            item_count: 10,
            loading: false,
            current_page: 1,
            current_page1: 1,
            buildingtype: '',
            districts: [],
            usermodal: false,
            userData: {
                organization: {},
                profile: {}
            },
            filtertype:[
                {type:'', label:this.$t('all_buildings')},
                {type:'1,2', label:this.$t('sustainable_buildings')},
                {type:'3', label:this.$t('not_sustainable_buildings')},
                {type:'4', label:this.$t('not_sustainable_buildings4')},
            ],
            seltype:1,
            router_link:'page=4'
        };
    },
    computed: {
        me() {
            return this.$store.state.me;
        },
        role() {
            return this.$store.state.role;
        },
        regions() {
            return this.$store.state.dictionary.region;
        },
        building_group() {
            return this.$store.state.dictionary.buildinggroup;
        }
    },

    mounted() {
        this.router_link=`org_id1=${this.$route.query.org_id1?this.$route.query.org_id1 :''}&org_id2=${this.$route.query.org_id2?this.$route.query.org_id2 :''}&region=${this.$route.query.region?this.$route.query.region :0}`
        this.current_page = this.$route.query.page ? parseInt(this.$route.query.page): 1   
        this.item_count = this.$route.query.item_count ? parseInt(this.$route.query.item_count) : 10
        this.seltype=this.$route.query.type? parseInt(this.$route.query.type):1
        this.__GET();
    },
    methods: {
        GeneratePasport(id) {
            this.loading = true
            this.loadDawer = true
            axios.post(`/building/specification/${id}/generate/`)
                .then(res => { 
                    this.drawer = true
                    this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link

                })
                .catch(e => {

                })
                .finally(() => {
                    this.loadDawer = false
                    this.loading = false

                })
        },
        downloadFile(file) {
            fetch(file)
                .then((resp) => resp.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.style.display = "none";
                    a.href = url;
                    // the filename you want
                    a.download = 'PasportBino' || "file.json";
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
        },
        paginate(val) {
            this.current_page = val;
            this.__GET()
        },
        paginateSize(val) {
            this.item_count = val
            this.current_page = 1

            this.__GET();
        },

        __GET() { 
            let offset = this.item_count * (this.current_page - 1);
            if ( this.seltype!=parseInt(this.$route.query.type) || this.item_count == 10) {

                this.$router.push(`/statistica/regionbuildings/${this.$route.params.region_id}/${this.$route.params.district_id}/${this.$route.params.org2}?type=${this.$route.query.type}&district=${this.$route.query.district}&page=${this.current_page}&item_count=${this.item_count}`)
            } 
            else{
                this.$router.push(`/statistica/regionbuildings/${this.$route.params.region_id}/${this.$route.params.district_id}/${this.$route.params.org2}&district=${this.$route.query.district}&page=${this.current_page}&item_count=${this.item_count}`)

            }
            let region_dis=this.$route.params.region_id!='0' ?`district=${this.$route.params.district_id}`:`region_id=${this.$route.params.district_id}`
            var link = `/building/specifications/?organization=${this.$route.params.org2!=0?this.$route.params.org2:''}&finalconclusion_id_in=${this.filtertype[this.seltype-1].type}&${region_dis}&limit=${this.item_count}&offset=${offset}`
            axios.get(link)
                .then((response) => {
                    this.buildsList = response.data.results;
                    this.page_count = Math.ceil(response.data.count / this.item_count);
                    this.current_page1 =this.$route.query.page ?  parseInt(this.$route.query.page) :  parseInt(this.$route.query.page)

                })
                .finally(() => {
                    this.loading = false
                })

        },
        routeTo(item, a) {
            if (item.buildingtype === "NEW") {
                this.$router.push({
                    path: `/new-build/${item.id}/${a}`,
                    params: {
                        id: this.$route.params.id
                    },
                    query: {
                        id: item.id
                    },
                });
            } else {
                this.$router.push({
                    path: `/exist-build/${item.id}/${a}`,
                    params: {
                        id: this.$route.params.id
                    },
                    query: {
                        id: item.id
                    },
                });
            }
        },
        getDistrict() {
            this.loading = true;
            axios.get(`/dictionary/district/?region__shared_id=${this.region}`)
                .then((response) => {

                    this.districts = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
         
        DownloadExel(id, name) {
            axios({
                url: `/building/generate/${id}/building/`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', `${name}-Bino-${id}.xlsx`);
                document.body.appendChild(fileLink);

                fileLink.click();
            }); 
        },
        UserModal(a) {
            if (a != null && a.profile != null) {
                this.userData = a
                this.usermodal = true
            }
        },
         
    }
};
</script>

<style lang="scss" scoped>
.top-header {
    width: 100%;
    padding: 20px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.top-header h1 {
    font-weight: 700;
    font-size: 25px;
    color: #2f525a !important;
}

.title-second-header {
    font-size: 18px;
    font-weight: 600;
    color: #345a63 !important;
}


</style>
